import { useState } from 'react'
import { useRequest } from '@10000/react'
import { Checkbox, CountryDropDown, Form, Radio, Submit, Text } from '../forms'
import { Body, Box } from '../widgets'
import { country } from '../../lookups'
import './PartnerPricingForm.scss'

export const PartnerPricingForm = ({ dark, submitPlacedToBottom, submitPadding }) => {
  const request = useRequest('tenant')
  const [agreed, setAgreed] = useState(true)

  const submitPartnerDetails = (values) => {
    if(values?.agree) {
      const formattedValues = {
        additionalInfo: `Interest: Shivoo partner pricing \nYears in operation: ${values.age} \nTypical number of clients: ${values.clients} \nTypical size of clients: ${values.clientSize} \nOther tools previously used? ${values.other} \nCurrently accredited: ${values.accredited === 1 ? 'Yes' : 'No'}`,
        company: country.name[values.company],
        ...values
      }
      setAgreed(true)
      return request('partnerRequested', formattedValues)
    } else {
      return setAgreed(false)
    }
  }

  return <Form onSubmit={submitPartnerDetails} style={{ alignItems: 'center', display: 'relative', paddingBottom: submitPlacedToBottom && 128, position: 'relative' }}>
    <Box column gap={16} maxWidth={800}>
      <Body size={22} lineHeight="32px">Fill out our form to unlock our Partner Subscriptions</Body>
      <Text name="firstname" title="Your first name *" required dark={dark}/>
      <Text name="lastname" title="Your last name *" required dark={dark}/>
      <Text name="email" title="Email *" type="email" required dark={dark}/>
      <Text name="company" title="Company name" dark={dark}/>
      <Text name="website" title="Company website" dark={dark}/>
      <CountryDropDown name="country" title="Country" dark={dark} search/>
      <Text name="age" title="Years in operation" dark={dark}/>
      <Text name="clients" title="Typical number of clients" dark={dark}/>
      <Text name="clientSize" title="Typical size of clients" dark={dark}/>
      <Text name="other" title="What other psychometric assessments, team diagnostics or organisational network analysis tools have you used in the past?" dark={dark}/>

      <Box column gap={8}>
        <Body alt weight={600}>Are you currently accredited through Pod&Hive?</Body>
        <Box gap={16}>
          <Radio name="accredited" label="Yes" value={true} dark={dark}/>
          <Radio name="accredited" label="No" value={false} dark={dark}/>
        </Box>
      </Box>

      <label>
        <Box gap={8} alignItems="center">
          <Checkbox type="checkbox" name="agree" required dark={dark} error={!agreed} />
          <Body color={dark ? 'black' : 'white'}>
            I have read and understood the&nbsp;
            <a
              href="https://shivoo.io/agreement"
              target="_blank"
              rel="noreferrer"
              style={{ color:dark ? 'black' : 'white', textDecoration: 'underline' }}>
                <b><i>Partner Agreement</i></b>
            </a>
            &nbsp;for Shivoo
          </Body>
        </Box>
      </label>

      <Box className={`partner-submit ${dark ? 'dark' : 'light'} ${submitPlacedToBottom ? 'bottom' : ''} ${submitPadding}`}>
        <Submit fullWidth>Submit</Submit>
      </Box>
    </Box>
  </Form>
}